import { useBreakpoint } from '@yuno/sdk-web-core/dist/hooks'
import { FC } from 'react'
import { PaymentMethodsDesktop } from './payment-methods-desktop'
import { PaymentMethodsMobile } from './payment-methods-mobile'

export const PaymentMethods: FC = () => {
  const { isMobile } = useBreakpoint()

  if (isMobile) {
    return <PaymentMethodsMobile />
  }

  return <PaymentMethodsDesktop />
}
